export const startGameBetOrderUrl = (gameId) => `/games/${gameId}/bet`;
